export default {"src":"/_next/static/media/curling.1e063eb2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};